export const Data = {
  profile: {
    name: "Arnaldo Gonzalez",
    ocupation: "Senior Software Engineer",
    location: "Miami, FL",
    email: "arnaldolgonzalez96@gmail.com",
    portfolio: "https://agonzalez.netlify.app",
    portfolioLabel: "agonzalez.netlify.app",
    image: "images/memoji-coding.png",
  },
  aboutMe: {
    label: "Profile",
    description:
      "Senior Software Engineer with 7+ years of experience designing and scaling cloud-native, distributed systems and e-commerce platforms. Proven expertise in AWS-based architectures, Shopify integrations, and ERP system connectivity, including building production applications that automate inventory, pricing, and product workflows. Strong background in microservices, CI/CD, and performance optimization, consistently delivering high-availability systems and measurable business impact.",
  },
  skills: {
    technicalLabel: "Skills",
    softLabel: "Core Strengths",
    technicalSkills: [
      "Frontend: React.js, Next.js, Redux, TypeScript, HTML5, CSS3",
      "Backend: Node.js, Express.js, REST APIs, GraphQL, WebSockets, Microservices",
      "Cloud & DevOps: AWS (EC2, S3, Lambda, Lightsail), Docker, Kubernetes, CI/CD (GitHub Actions), Reverse Proxy",
      "Databases: PostgreSQL, MongoDB, MySQL, Firebase",
    ],
    softSkills: [
      "Distributed Systems",
      "System Design",
      "API Integration",
      "Performance Optimization",
      "Monitoring & Logging",
    ],
  },
  socialMedia: {
    label: "Professional Profiles",
    social: [
      {
        title: "LinkedIn",
        label: "arnaldo-gonzalez-10025216b",
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/arnaldo-gonzalez-10025216b",
        className: "bxl-linkedin-square",
      },
      {
        title: "GitHub",
        label: "ArnaldoGonzalez81318",
        name: "github",
        url: "https://github.com/ArnaldoGonzalez81318",
        className: "bxl-github",
      },
    ],
  },
  experience: {
    works: [
      {
        title: "Senior Software Engineer",
        period: "Jan 2021 - Present",
        company: "Technopack Corporation",
        description: [
          "Designed and deployed cloud-hosted applications on AWS Lightsail, supporting scalable internal tools and e-commerce integrations.",
          "Architected and developed 4 private Shopify applications, enabling dynamic product specification management, proxy-based content delivery, file storage and retrieval, and ERP integration.",
          "Built a NetSuite and Shopify integration system, automating inventory synchronization, pricing updates, and product data workflows.",
          "Developed backend services and APIs using Node.js to support real-time data processing and system interoperability.",
          "Implemented reverse proxy architecture to route and serve dynamic application content within Shopify storefronts.",
          "Led migration to a React-based frontend architecture, improving performance by ~40%.",
          "Owned end-to-end CI/CD pipelines, enabling zero-downtime deployments and reducing defects by ~35%.",
          "Improved system reliability through monitoring, logging, and performance optimization.",
        ],
      },
      {
        title: "Frontend Developer",
        period: "Jan 2020 - Jul 2020",
        company: "YankeeKicks",
        description: [
          "Developed YankeeKicks online store from scratch using Shopify and modern frontend technologies.",
          "Built a high-performance e-commerce experience, increasing conversion rates by 18%.",
          "Reduced load time by 2.4 seconds via code-splitting and lazy loading.",
          "Delivered A/B-tested features improving engagement by 12%.",
        ],
      },
      {
        title: "Software Developer",
        period: "Feb 2018 - Nov 2019",
        company: "FK Irons",
        description: [
          "Developed Evenflo Colours online store from scratch, delivering a production-ready e-commerce platform.",
          "Led performance, layout, and UI/UX improvements across fkirons.com, darklab.com, and microbeau.com.",
          "Built reusable UI components and backend integrations using React.js, Node.js, and Firebase.",
          "Supported CI/CD workflows, improving deployment efficiency by ~35%.",
        ],
      },
    ],
    academic: [
      {
        career: "Web Application Development Engineer",
        date: "Jan 2017 - Aug 2018",
        degree: "Diploma",
        institution: "Florida Vocational Institute (FVI)",
        description: [
          "Frontend Engineering (JavaScript, HTML5, CSS3), React / Angular, Node.js and APIs, SQL / NoSQL.",
          "System Architecture (AJAX, request-response lifecycle), OAuth and API integrations, UI/UX Design.",
          "Performance Optimization, WordPress Development.",
        ],
      },
    ],
    projects: [
      {
        name: "NetSuite + Shopify ERP Integration Platform",
        company: "Technopack Corporation",
        linkLabel: "Private / internal deployment",
        description: [
          "Built an integration layer to synchronize inventory, pricing, and product data between NetSuite and Shopify.",
          "Automated core merchandising workflows that reduced manual operations and improved catalog accuracy.",
          "Designed the platform for reliability and extensibility using Node.js services and API-driven workflows.",
        ],
      },
      {
        name: "Private Shopify App Suite",
        company: "Technopack Corporation",
        linkLabel: "Private Shopify applications",
        description: [
          "Architected and shipped 4 private Shopify apps for product specification management, content delivery, and file retrieval workflows.",
          "Enabled ERP-connected product operations and merchant-facing tooling for internal teams.",
          "Supported scalable app behavior inside Shopify storefronts with secure proxy-based routing.",
        ],
      },
      {
        name: "Shopify Reverse Proxy Content Layer",
        company: "Technopack Corporation",
        linkLabel: "Private storefront infrastructure",
        description: [
          "Implemented reverse proxy infrastructure to serve dynamic application content within Shopify storefronts.",
          "Improved flexibility for embedded experiences and custom data-driven rendering without disrupting the storefront flow.",
          "Deployed on AWS-hosted infrastructure supporting internal tools and commerce integrations.",
        ],
      },
      {
        name: "Portfolio Website",
        company: "Personal",
        url: "https://agonzalez.netlify.app",
        linkLabel: "View live site",
        description: [
          "Personal portfolio showcasing projects, experience, and skills in a resume-style web experience.",
          "Designed to present professional work clearly across desktop and mobile devices.",
        ],
      },
    ],
  },
};